<template>
  <div class="details-component" style="margin-top: 44px">
    <div class="details-component__header">
      <h1>{{ $t('ticket_types.types') }}</h1>
      <div v-if="canEditTypes" class="details-component__header_right">
        <a class="link" v-on:click="toggleListModalOpen">
          {{ $t('ticket_types.add_type') }}
          <i class="icon icon--plus"></i>
        </a>
      </div>
    </div>
    <TicketTypesList v-if="ticketsList" :ticketsList="ticketsList" :canEditTypes="canEditTypes" />
    <ListModal v-if="showListModal && canEditTypes" @cancel="closeListModal($event)" @confirmed="onSubmit($event)">
      <TicketTypeForm />
    </ListModal>
  </div>
</template>

<script>
import TicketTypeForm from "./ui/TypeForm";
import TicketTypesList from "./ui/TypesList";
import ListModal from "../../common/ListModal";
import { mapGetters } from "vuex";
import { apiService } from "./api/services";
import { configData } from "./mixins/configData"
import { submitData } from "./mixins/submitData";

export default {
  components: {
    TicketTypeForm,
    TicketTypesList,
    ListModal
  },
  mixins: [apiService, configData, submitData],
  props: ['kioskId', 'canEditTypes'],
  created() {
    this.getTypesList()
  },
  computed: {
    ...mapGetters({
      ticketData: 'tenants/ticketTypes/ticketData',
      ticketsList: 'tenants/ticketTypes/ticketsList'
    })
  },
  data() {
    return {
      showListModal: false,
      columns: ['name', 'type', 'price', 'available', 'edit', 'remove_product'],
      options: {
        texts: {
          noResults: this.$t('tenants.no_matching_records'),
          count: this.$t('tables.count'),
        },
        filterable: false,
        rowClassCallback: () => 'VueTables__row',
        headings: {
          type: () => this.$t('ticket_types.type'),
          name: () => this.$t('common.name'),
          price: () => this.$t('ticket_types.price'),
          available: () => this.$t('ticket_types.available'),
          remove_product: () => (''),
          edit: () => (''),
        }
      }
    }
  },
  methods: {
    toggleListModalOpen() {
      this.showListModal = !this.showListModal;
    },
    closeListModal(event) {
      this.showListModal = false;
    },
    getTypesList() {
      this.$store.dispatch('tenants/ticketTypes/clear')
      this.getList(this.kioskId)
        .then(response => {
          Object.values(response.data).forEach(item => {
            let data = {
              id: item.id,
              name: item.name,
              description: item.description,
              availability: item.availability,
              price_rule_type: item.price_rule_type,
              pricing_rule: item.pricing_rule,
              kioskId: this.kioskId,
              id_code_enabled: item.id_code_enabled,
              icon: item.icon,
              mode: item.mode
            }
            this.$store.dispatch('tenants/ticketTypes/setToList', data)
          })
        }).catch((response) => {
          console.log('error', response)
        })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/index.vue